import React from "react";

type BurgerMenuIconProps = {
  color: string;
};

const BurgerMenuIcon: React.FC<BurgerMenuIconProps> = ({ color }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.5 5.83333C22.5 5.09583 21.9042 4.5 21.1667 4.5H5.16667C4.42917 4.5 3.83333 5.09583 3.83333 5.83333C3.83333 6.57083 4.42917 7.16667 5.16667 7.16667H21.1667C21.9042 7.16667 22.5 6.57083 22.5 5.83333ZM22.5 12.5C22.5 11.7625 21.9042 11.1667 21.1667 11.1667H5.16667C4.42917 11.1667 3.83333 11.7625 3.83333 12.5C3.83333 13.2375 4.42917 13.8333 5.16667 13.8333H21.1667C21.9042 13.8333 22.5 13.2375 22.5 12.5ZM3.83333 19.1667C3.83333 19.9042 4.42917 20.5 5.16667 20.5H21.1667C21.9042 20.5 22.5 19.9042 22.5 19.1667C22.5 18.4292 21.9042 17.8333 21.1667 17.8333H5.16667C4.42917 17.8333 3.83333 18.4292 3.83333 19.1667Z"
        fill={color}
      />
    </svg>
  );
};

export default BurgerMenuIcon;
